<template>
  <div class="accordion-item">
    <div class="accordion-item__title" v-if="!insurance && !subscription && data.nomPublic"><h4>{{ data.nomPublic }}</h4></div>
    <div class="accordion-item__title" v-if="insurance && !subscription"><h4>Assurance : {{ data.nom }}</h4></div>
    <div class="accordion-item__title" v-if="!insurance && subscription"><h4>{{ data.libellePublic }}</h4></div>
    <div class="accordion-item__content" v-if="!subscription"><p>{{ data.mentionsLegales }}</p></div>
    <div class="accordion-item__content" v-if="subscription">
      <p v-if="data.prixInitial > data.prixMajore">{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(data.prixMajore) }} par mois pendant {{ data.promoDuration }} puis {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(data.prixInitial) }} par mois. Engagement {{ data.commitment }}</p>
      <p v-else>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(data.prixInitial) }} par mois. Engagement {{ data.commitment }}</p>
      <p><span>{{ data.mentionsLegales }}</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    data: Object,
    insurance: Boolean,
    subscription: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.accordion-item{
  padding: 30px;
  border-bottom: 1px solid darken($white, 8%);

  &:last-child{
    margin-bottom: 0;
    border: none;
  }

  .accordion-item__{
    &title{
      margin-bottom: 20px;
      position: relative;
      padding-right: 40px;

      h4{
        font-size: px2rem(14px);
        line-height: px2rem(20px);
      }
    }

    &content{
      p{
        font-size: px2rem(12px);
        line-height: px2rem(18px);
      }
    }
  }
}
</style>
